package dev.moetz.chatoverlay

import dev.moetz.chatoverlay.page.*
import dev.moetz.materialize.MaterializeColor
import kotlinx.browser.window
import react.create
import react.dom.client.createRoot
import web.dom.document

fun main() {

    MaterializeColor.setColorPalette(MaterializeColor.ColorPalette.GreenBlue)
    val container = document.createElement("div")
    document.body.appendChild(container)

    val path = window.location.pathname

    val element = when {
        path.isBlank() || path == "/" -> {
            ConfigPageService.create {
                manager = ConfigPageServiceManager()
            }
        }

        path.startsWith("/overlay") || path.startsWith("overlay") -> {
            ChatOverlayService.create {
                manager = ChatOverlayServiceManager()
            }
        }

        else -> {
            NotFoundPageService.create {

            }
        }
    }

    createRoot(container).render(element)
}